var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 26L17 21L18.4 19.55L21 22.15V14H23V22.15L25.6 19.55L27 21L22 26ZM16 30C15.45 30 14.9792 29.8042 14.5875 29.4125C14.1958 29.0208 14 28.55 14 28V25H16V28H28V25H30V28C30 28.55 29.8042 29.0208 29.4125 29.4125C29.0208 29.8042 28.55 30 28 30H16Z",
    fill: "#535862"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.3cd29d307b01adc01fe75cb8543f3566.svg";
export { ForwardRef as ReactComponent };